import {Component, inject} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PowerStopService} from '@core/services/power-stop.service';


@Component({
  selector: 'app-en-primeur-info-message-modal',
  templateUrl: './en-primeur-info-message-modal.component.html',
  styleUrls: ['./en-primeur-info-message-modal.component.scss'],
  imports: [ModalContainerComponent]
})
export class EnPrimeurInfoMessageModalComponent {
  activeModal = inject(NgbActiveModal);
  private powerStopService = inject(PowerStopService);

  goToCheckout() {
    this.powerStopService.goToPowerStop('en_primeur_info_message_modal_go_to_checkout_click');
  }
}
